import type { EnsembleData } from './weather-types.js'

export async function fetchEnsemble(
  lat: number,
  lon: number,
  options: {
    signal?: AbortSignal | undefined
    startDate?: string | undefined
    endDate?: string | undefined
  } = {}
): Promise<EnsembleData | null> {
  const base = import.meta.env.VITE_API_BASE_URL ?? ''
  let url = `${base}/weather/ensemble?latitude=${lat.toFixed(2)}&longitude=${lon.toFixed(2)}`
  if (options.startDate) url += `&start_date=${options.startDate}`
  if (options.endDate) url += `&end_date=${options.endDate}`

  try {
    const response = await fetch(url, options.signal ? { signal: options.signal } : {})
    if (!response.ok) return null
    return (await response.json()) as EnsembleData
  } catch {
    return null
  }
}
